import React from 'react'
import Button from '../../../../../../../Components/Buttons/Button'
import { H4 } from '../../../../../../../Styles/typography'
import { ThirdStepEl } from '../Elements'
import GroupRegistrationStore from '../Store/GroupRegistrationStore'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { object, string } from 'yup'
import Input from '../../../../../../../Components/Input/Input'

function ThirdStep() {
  const {
    message,
    setMessage,
    next,
    back,
  } = GroupRegistrationStore.useContainer()

  const {
    control,
    handleSubmit,
    errors,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: { message: message },
    resolver: yupResolver(
      object({
        message: string()
          .max(500, 'Max 500 characters are allowed')
          .required('Enter a Message'),
      }),
    ),
  })

  const onSubmit = ({ message }) => {
    setMessage(message)
    next()
  }

  return (
    <>
      <div className='back-btn' onClick={() => back()}>
        <KeyboardBackspaceIcon /> Back
      </div>
      <ThirdStepEl>
        <H4 bold>Message for the Teacher</H4>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            as={<Input type='textarea' maxlength={500} />}
            control={control}
            name='message'
            placeholder='Message'
            error={errors?.message}
          />
          <Button
            name='Proceed'
            type={'primary'}
            buttonType={'submit'}
            disabled={isSubmitting}
            onClick={() => {}}
          />
        </form>
      </ThirdStepEl>
    </>
  )
}

export default ThirdStep
